import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Col, Container, Form, Image, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams, useHistory
} from 'react-router-dom'
import * as _ from 'lodash'

import moment from 'moment'
import Pagination from "react-js-pagination";
import { useImmer } from 'use-immer'
import * as actions from '../../../redux/actions'

import config from '../../../constants/config'
import images from '../../../constants/images'
import { workerHasPermission } from '../NewJob/Job'
import { instanceSocketClient } from '../../../service/InstanceSocketClient'

import { css } from 'glamor'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'

import { InputSelect } from '../../../components/InputSelect'
import { copyObject, formatPhoneNumberUS, phoneFormat, randomId, __pick } from '../../../utils'
import InputSearchUsers from '../../../components/InputSearchUsers/InputSearchUsers'
import { ClientT } from '../../../types/Users'
import { FiltersT, InitFiltersJobs, saveFilters } from './JobsUtils'
import InputDatePickerT from '../../../components/InputDatePicker/InputDatePicker'
import LineItemsSeeBy from './LineItemsSeeBy'
import { removePrefixUS } from '../../../utils/utilsT'
import TableBootstrap from '../../../components/TableBootstrap/TableBootstrap'
import { TdLink } from '../../../components/TableBootstrap/TdLink'
import { IAppState } from '../../../redux/reducers'
import { AuthStateT } from '../../../redux/reducers/authReducer'
import { getJobMoveDate } from '../NewJob/JobUtils'
import { JobT } from '../../../types/Job'
import { OptionsJobStatus, OptionsJobType } from '../NewJob/OptionsFieldsJob'
import { currentUserIsClient, currentUserIsManager, currentUserIsWorker } from '../../../utils/currentUser'
import PendingScreen from './PendingScreen'
import { AxiosInstance } from '../../../utils/RequestMethods'
import { Grid } from '@mui/material'

const formatDateTime = "MM/DD/YYYY h:mm A";

const style = {
  fixHeightSelect: css({
    height: "100%",
    padding: "0px",
  }),
  inputSearchUsers: css({
    "margin": "0px !important"
  }),
  btnClear: css({
    "cursor": "pointer",
    "top": "10px",
    "position": "absolute",
    "right": "10px",
  }),
  tdLink: css({
    ':hover': { "textDecoration": 'none' },
  })
}

const AdminFields = {
  id: -1,
  job_addresses: '',
  job_client: -1,
  job_crew: '',
  job_datetime: '',
  job_status: '',
  job_type: ''
}

type AdminFieldsType = typeof AdminFields

const ClientFields = {
  id: -1,
  job_datetime: '',
  job_type: '',
  job_status: '',
  job_addresses: '',
  job_crew: ''
}

type ClientFieldsType = typeof ClientFields

const ManagerFields = {
  id: -1,
  job_addresses: '',
  job_datetime: '',
  job_status: '',
  job_type: ''
}

type ManagerFieldsType = typeof ManagerFields

const WorkerFields = {
  id: -1,
  job_addresses: '',
  job_datetime: '',
  job_status: '',
  job_type: ''
}

type WorkerFields = typeof WorkerFields

interface JobsProps {

}

const convertDBFieldToLabel = (field: string): string => {
  switch (field) {
    case 'job_addresses':
      return 'Address'
    case 'job_crew':
      return 'Workers'
    case 'job_datetime':
      return 'Date'
    case 'job_status':
      return 'Status'
    case 'job_type':
      return 'Moving Type'
    default:
      return field
  }
}

const getJobs = async (params = {}): Promise<any> => {
  let options = {
    data: params
  }
  return await AxiosInstance.get(`${config.url.wpJson}/wp/v2/jobs`, options)
}

const PerPage = 50;

const JobsPage: React.FunctionComponent<JobsProps> = ({ }): JSX.Element => {
  let match = useRouteMatch()
  let { page } = useParams();
  const dispatch = useDispatch();
  let auth: AuthStateT = useSelector((state: IAppState) => state.auth)
  let filtersJobs = useSelector((state: IAppState) => state.filtersJobs)
  let socketState = useSelector((state: IAppState) => state.socket)
  // let jobState = useSelector(state => state.jobs)
  const userRole = _.isArray(auth?.userData?.roles) && auth?.userData?.roles?.length > 0 ? auth.userData.roles[0] : "" // Assume only one role ih array

  const currentUserId = auth.userData && auth.userData.id
  let history = useHistory()
  let [jobs, setJobs] = React.useState([])
  let [workerInfo, setWorkerInfo] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [socketIsReady, setSocketIsReady] = React.useState(false)
  const [optionsJobStatus, setOptionsJobStatus] = React.useState([]);
  const [filters, setFilters] = React.useState(InitFiltersJobs);
  const isManager = currentUserIsManager()
  const isWorker = currentUserIsWorker()
  const isClient = currentUserIsClient()
  const notPending = isManager || isWorker || isClient


  const [paginationInfo, setPaginationInfo] = React.useState({
    activePage: 1,
    itemsCountPerPage: PerPage,
    totalPages: 0,
    pageRangeDisplayed: 5,
    total: 0,
    clientId: 0,
  })


  React.useEffect(() => {


  }, [])


  React.useEffect(() => {
    let activePage = page ? page : 1

    let cloneFilters = { ...filters, ...filtersJobs }
    let preparedFilters = prepareFilters(cloneFilters)
    setFilters(cloneFilters)
    setPaginationInfo({
      ...paginationInfo, ...{
        activePage: activePage
      }
    })
    reloadJobs(activePage, preparedFilters)


  }, [page])

  React.useEffect(() => {
    if (socketState && socketState.isReady && !socketIsReady) {
      setSocketIsReady(true)
      // console.log("instanceSocketClient", instanceSocketClient)
      socketListeners()
    }

    return () => {
      // instanceSocketClient.removeListener("")
    }
  }, [socketState])



  /**
   * socketListeners
   */
  const socketListeners = () => {

    instanceSocketClient.on("update-jobs", (args) => {
      console.log("socket->update-jobs")
      let activePage = page ? page : 1
      fetchJobs(activePage, filters, true)
      instanceSocketClient.emit("feedback-update-jobs", { path: "jobs", platform: "webapp" })
      //console.log("socket-> update-jobs")
    })
    instanceSocketClient.on("new-jobs", (args) => {
      console.log("socket->new-jobs")
      let activePage = page ? page : 1
      fetchJobs(activePage, filters, true)
      instanceSocketClient.emit("feedback-new-jobs", { path: "jobs", platform: "webapp" })
    })

  }




  const formatDate = (dt: string): string => {
    let d = new Date(dt)
    return d.getMonth() + '/' + d.getDay() + '/' + d.getFullYear() + ' ' + d.getHours() + ':' + d.getMinutes()
  }


  /**
   *
   * @param jobId
   */
  const openJob = (jobId: number): void => {
    history.push({
      pathname: '/job/' + jobId
    })
  }


  /**
   *
   * @param job
   */
  const onPressItemRow = (job: JobT) => {
    openJob(job.id)
  }

  /**
   * getOptionsJobStatus
   */
  const getOptionsJobStatus = (): Array<any> => {
    let options = {
      'client': __pick(OptionsJobStatus, ['scheduled', 'completed']),
      'worker': __pick(OptionsJobStatus, ['scheduled', 'completed']),
      'manager': OptionsJobStatus,
      "external_admin": OptionsJobStatus,
      'administrator': OptionsJobStatus
    }
    const arr = options[userRole] ? options[userRole] : {}
    // console.log("arr",arr)
    return Object.keys(arr).map((key, index) => {
      return { label: arr[key], value: key }
    })

  }

  /**
   * getOptionsJobType
   */
  const getOptionsJobType = (): Array<any> => {
    let options = {
      'client': OptionsJobType,
      'worker': OptionsJobType,
      'manager': OptionsJobType,
      "external_admin": OptionsJobType,
      'administrator': OptionsJobType
    }
    const arr = options[userRole] ? options[userRole] : {}
    // console.log("arr",arr)
    return Object.keys(arr).map((key, index) => {
      return { label: arr[key], value: key }
    })

  }



  const reloadJobs = async (page: number = 1, filters = {}): Promise<void> => {
    setLoading(true)
    fetchJobs(page, filters, true).then(res => {
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
    })

  }


  const mergeResults = (arr1: Array<JobT>, arr2: Array<JobT>) => {
    let items = _.cloneDeep(arr1)
    arr2.map((item, index) => {
      const findIndex = items.findIndex((x) => x.id == item.id)
      if (findIndex != -1) {
        items[findIndex] = _.cloneDeep(item)
      } else {
        items.push(item)
      }
    })
    return items
  }

  /**
   *
   * @param page
   */
  const fetchJobs = async (page: number = 1, filters = {}, rest = false): Promise<void> => {
    console.log("fetchJobs", page)
    console.log("rest", rest)
    let params = {
      page: page,
      per_page: PerPage,
      // order: "desc",
      ...filters
    }
    try {
      let res = await getJobs(params)
      if (res?.data && _.isArray(res?.data) && res.headers['x-wp-totalpages']) {
        let data = rest ? res.data : _.uniqBy(mergeResults(jobs, res.data), 'id')
        if (res.headers['x-wp-totalpages'] && res.headers['x-wp-total']) {
          const total = res.headers['x-wp-total']
          const totalPages = res.headers['x-wp-totalpages']
          setPaginationInfo((draft) => {
            draft.total = total
            draft.totalPages = totalPages
            draft.activePage = page
            return draft
          })
        }
        setJobs(data)
        return res;
      }
    } catch (error) {
      throw new Error(error)
    }

  }

  /**
   *
   * @param page
   */
  const goToPage = (page) => {
    let path = match.path
    history.push({
      pathname: `${getBaseUrl(match)}/${page}`
    })
  }

  /**
   *
   * @param match
   */
  const getBaseUrl = (match) => {
    let url = match.url
    return url.replace(/\/[0-9]+$/g, '');
  }

  const renderJobs = (): JSX.Element => {
    switch (userRole) {
      case 'administrator':
        return renderAdministratorTable()
      case 'client':
        console.log('ClientFields: ', Object.assign({}, ClientFields))
        //return renderTable(Object.assign({}, ClientFields), jobs, 'client')
        return renderClientTable()
      case 'manager':
        return renderAdministratorTable()
      case 'external_admin':
        return renderAdministratorTable()
      case 'worker':
        return renderWorkerTable()
      default:
        return null
    }
  }




  /**
   * onChangeFilter
   * @param key
   * @param value
   */
  const onChangeFilter = async (key, value) => {
    let cloneFilters = copyObject(filters)
    cloneFilters[key] = value

    setFilters(cloneFilters)
    // save in store redux
    dispatch(saveFilters(cloneFilters))
    let prepareFilter = prepareFilters(cloneFilters)
    let activePage = page ? page : 1
    goToPage(1)
    try {
      await reloadJobs(activePage, prepareFilter)
    } catch (error) {

    }
  }

  /**
   * prepareFilters
   * @param filters
   */
  const prepareFilters = (filters: FiltersT) => {
    let params = {}

    if (filters.startDate != "") {
      params['after'] = moment(filters.startDate, "YYYY/MM/DD").format("YYYY-MM-DD 00:00:00")
    }
    if (filters.endDate != "") {
      params['before'] = moment(filters.endDate, "YYYY/MM/DD").format("YYYY-MM-DD 00:00:00")
    }
    if (filters.jobStatus.length > 0) {
      params['jobStatus'] = filters.jobStatus
    }
    if (filters.jobType.length > 0) {
      params['jobType'] = filters.jobType
    }
    if (filters.client) {
      params['client'] = filters.client.id
    }
    return params;
  }


  /**
   *
   * @param id
   */
  const generateUrlJob = (job: JobT) => {
    return `/job/${job.id}`
  }


  const canSeeColumnCompany = (jobs: Array<JobT>): boolean => {

    return false
  }

  const getScheduledDate = (job: JobT) => {

  }

  /**
   * renderAdministratorTable
   */
  const renderAdministratorTable = (): JSX.Element => {
    return (
      <>
        <TableBootstrap<JobT>
          columns={['Last Contact Date', 'Scheduled Date', 'Status', 'Type', 'Phone', 'Client', 'Address', 'Company', 'Crew', 'Seen By']}
          data={jobs}
          // customRenderColumn={customRenderColumn}
          onClickItem={onPressItemRow}
          renderRowItem={(job, index) => {
            const to = generateUrlJob(job)

            return (
              <>
                <TdLink to={to}>{job.lastContactDate && moment.utc(job.lastContactDate).local().format(formatDateTime)}</TdLink>
                {/* <TdLink to={to}>{job.scheduledDate && moment.utc(job.scheduledDate).local().format('MM/DD/YYYY HH:mm:ss')}</TdLink> */}

                <TdLink to={to}>{getJobMoveDate(job, formatDateTime, true)}</TdLink>

                {/* <TdLink to={to}>{job.date && moment(job.date).format('MM/DD/YYYY HH:mm:ss')}</TdLink> */}
                <TdLink to={to}>{_.startCase(job.jobStatus)}</TdLink>
                <TdLink to={to}>{_.startCase(job.jobType)}</TdLink>
                <TdLink to={to}>{`${formatPhoneNumberUS(job.client.phone, false)}`}</TdLink>
                <TdLink to={to}>{`${job.client.firstName} ${job.client.lastName}`}</TdLink>
                <TdLink to={to}>{job.locations && job.locations[0] && job.locations[0].address}</TdLink>
                <TdLink to={to}>{job.companyInfo && job.companyInfo.name}</TdLink>
                <TdLink to={to}>{parseCrew(job)}</TdLink>
                <TdLink><LineItemsSeeBy job={job} socket={instanceSocketClient} /></TdLink>

                {/* <TdLink to={to}>{job.scheduledDate}</TdLink> */}
              </>
            )
          }} />
      </>
    )
  }


  /**
   * parseCrew
   * @param job
   */
  const parseCrew = (job: JobT) => {
    const crew = job.crew && _.isArray(job.crew) ? job.crew : []

    return (
      <div className="d-flex flex-row flex-wrap">
        {crew.map((item, index) => {
          const uniqeId = randomId()
          return (
            <div key={index}>
              <OverlayTrigger
                key={index}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-${index}-${uniqeId}`}>
                    {!item.id ? 'Anon' : (isClient ? `${item.firstName} ${item.lastName.charAt(0)}.` : `${item.firstName} ${item.lastName}`)}
                  </Tooltip>
                }>
                <Image style={{
                  height: 40,
                  padding: 2,
                  width: 40
                }} src={item.profilePic ? item.profilePic : images.noProfilePic} />
              </OverlayTrigger>
            </div>
          )
        })}
      </div>
    )
  }

  /**
   *
   */
  const renderClientTable = (): JSX.Element => {
    return (
      <>

        <TableBootstrap columns={['Scheduled Date', 'Status', 'Type', 'Address', 'Crew']}
          onClickItem={onPressItemRow} data={jobs} renderRowItem={(job, index) => {
            const to = generateUrlJob(job)
            return (
              <>
                {/* <TdLink to={to}>{job.scheduledDate && moment.utc(job.scheduledDate).local().format('MM/DD/YYYY HH:mm:ss')}</TdLink> */}
                <TdLink to={to}>{getJobMoveDate(job, formatDateTime, true)}</TdLink>
                <TdLink to={to}>{_.startCase(job.jobStatus)}</TdLink>
                <TdLink to={to}>{_.startCase(job.jobType)}</TdLink>

                <TdLink to={to}>{job.locations && job.locations[0] && job.locations[0].address}</TdLink>
                <TdLink to={to}>{parseCrew(job)}</TdLink>
              </>
            )
          }} />
      </>
    )
  }


  const workerIsSales = (jobs, workerId) => {
    if (_.isArray(jobs)) {
      return jobs.find((job) => workerHasPermission('sales', job, workerId))
    }

    return false;
  }
  /**
   * renderWorkerTable
   */
  const renderWorkerTable = (): JSX.Element => {
    let columns = ['Scheduled Date', 'Status', 'Type', 'Address']
    let isSales = workerIsSales(jobs, currentUserId)
    if (isSales) {
      columns = ['Last Contact Date', 'Scheduled Date', 'Status', 'Type', 'Address']
    }
    return (
      <>
        <TableBootstrap
          columns={columns}
          data={jobs}
          onClickItem={onPressItemRow}
          renderRowItem={(job, index) => {
            const to = generateUrlJob(job)
            return (
              <>
                {isSales && <TdLink to={to}>{job.lastContactDate && moment.utc(job.lastContactDate).local().format(formatDateTime)}</TdLink>}
                <TdLink to={to}>{getJobMoveDate(job, formatDateTime, true)}</TdLink>
                {/* <TdLink to={to}>{job.scheduledDate && moment.utc(job.scheduledDate).local().format('MM/DD/YYYY HH:mm:ss')}</TdLink> */}
                <TdLink to={to}>{_.startCase(job.jobStatus)}</TdLink>
                <TdLink to={to}>{_.startCase(job.jobType)}</TdLink>
                <TdLink to={to}>{job.locations && job.locations[0] && job.locations[0].address}</TdLink>
                {/* <TdLink to={to}>{parseCrew(job)}</TdLink> */}

              </>
            )
          }} />

      </>
    )
  }

  /**
   *
   * @param values
   * @param type
   */
  const getSelectedValues = (values: Array<string> = [], type: "jobStatus" | "jobType" = "jobStatus") => {
    if (_.isArray(values)) {
      let options = type == "jobType" ? getOptionsJobType() : getOptionsJobStatus()
      return values.map((item, index) => {
        return options.find((x) => x.value == item)
      })
    }
    return []
  }


  /**
   *
   */
  const renderFormFilter = () => {
    return (
      <Container className="mb-2 mt-5" fluid>
        <Grid container spacing={3} >

          <Grid item xs={12} sm={3} >
            <div className="d-flex ">
              <div className="mr-2 flex-fill">
                <Form.Label>Start Date</Form.Label>
                <InputDatePickerT
                  className="input-material"
                  style={{ width: '100%' }}
                  selectedDate={`${filters.startDate}`}
                  onChangeDate={(val) => onChangeFilter("startDate", val)}
                  onChange={(date) => {

                  }}
                  dateFormat="MM/dd/yyyy"
                  // dateFormat="yyyy-MM-dd"
                  btnClear={true}

                />

              </div>
              <div className="mr-2 flex-fill">
                <Form.Label >End Date</Form.Label>
                <InputDatePickerT
                  className="input-material"
                  style={{ width: '100%' }}
                  selectedDate={`${filters.endDate}`}
                  onChangeDate={(val) => onChangeFilter("endDate", val)}

                  onChange={(date) => {

                  }}
                  dateFormat="MM/dd/yyyy"
                  //  dateFormat="MM/dd/yyyy"
                  btnClear={true}
                />
              </div>

            </div>


          </Grid>

          <Grid item xs={12} sm={3} >
            <Form.Label >Job Status</Form.Label>
            <InputSelect
              styleMaterial={true}
              allNull

              // className="basic-multi-select"
              // classNamePrefix="select"
              className={` ${style.fixHeightSelect}`}
              // className="basic-multi-select input-material"
              isMulti={true}
              // multi
              is2D
              data={getOptionsJobStatus()}
              selectedValue={getSelectedValues(filters.jobStatus, "jobStatus")}
              onChangeValue={(selected) => {
                // console.log("selected", selected)
                let values = _.isArray(selected) ? selected.map((item) => item.value) : []
                onChangeFilter('jobStatus', values)
              }}
            />

          </Grid>
          <Grid item xs={12} sm={3} >
            <Form.Label >Job Type</Form.Label>
            <InputSelect

              styleMaterial={true}
              allNull
              className={` ${style.fixHeightSelect}`}
              isMulti={true}

              is2D

              data={getOptionsJobType()}
              selectedValue={getSelectedValues(filters.jobType, "jobType")}
              onChangeValue={(selected) => {
                // console.log("selected", selected)
                let values = _.isArray(selected) ? selected.map((item) => item.value) : []
                onChangeFilter('jobType', values)
              }}
            />

          </Grid>
          {(userRole == "administrator" || userRole == "manager" || userRole == "external_admin") && <Grid item xs={12} sm={3} >
            <Form.Label >Client</Form.Label>
            <InputSearchUsers
              query={{
                roles: ['client']
              }}
              className={`input-material ${style.inputSearchUsers}`}
              style={{ margin: 0 }}
              textValue={`${filters.client ? `${filters.client.firstName} ${filters.client.lastName}` : ''}`}
              onChange={(event) => {
                if (event.target.value == "" && filters.client != null) {
                  onChangeFilter("client", null)
                }
                console.log("event", event.target.value)
              }}
              onSelectUser={(user) => {
                //console.log('CHANGE USER: ', user)
                console.log("user", user)
                onChangeFilter("client", user)
                // console.log('cloneWorker ' + index, cloneWorker)
              }}

            />
          </Grid>}
        </Grid>
      </Container >
    )
  }
  const renderSectionPagination = () => {
    return (
      <div className="d-flex flex-row">
        <div className=" p-2 ">
          <Pagination
            hideFirstLastPages={true}
            firstPageText="First"
            lastPageText="Last"

            prevPageText="&lt; Prev"

            nextPageText="Next &gt;"
            linkClass="page-link"
            itemClass="page-item"
            activePage={Number(paginationInfo.activePage)}
            itemsCountPerPage={paginationInfo.itemsCountPerPage}
            totalItemsCount={Number(paginationInfo.total)}
            pageRangeDisplayed={paginationInfo.pageRangeDisplayed}
            onChange={(page) => {
              console.log("page", page)
              goToPage(page)
            }}
            getPageUrl={(i) => {
              return `${getBaseUrl(match)}/${i}`
            }}
          />

        </div>
        {(userRole.includes('administrator') || userRole.includes('manager') || userRole.includes('external_admin') || userRole.includes('client')) && <div className="">
          <Button

            onClick={() => { history.push(`/job/add-job`) }}
            variant='success'>
            Add Job
          </Button>
        </div>}
      </div>
    )
  }

  const renderContent = () => {
    return (
      <>
        {renderSectionPagination()}
        <LoadingSpinner loading={loading} >


          {renderFormFilter()}
          {renderJobs()}
        </LoadingSpinner>
        {renderSectionPagination()}
      </>
    )
  }

  console.log("notPending", notPending)
  return (
    <Container className="mb-5" fluid>

      {!notPending ? <PendingScreen /> : renderContent()}

    </Container>
  )

}

const Jobs: React.FC<{}> = ({ }) => {
  let match = useRouteMatch();
  return (
    <Switch>
      <Route path={`${match.path}/:page`}>
        <JobsPage />
      </Route>
      <Route path={match.path}>
        <JobsPage />
      </Route>
    </Switch>
  )
}
export default Jobs
